import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTemplateConfig } from "../templates/templateConfigContext";
import { formatCategoryName, formatProductTitle } from "../utils/titleFormat";

const ScrollToTop: React.FC = () => {
    const { pathname, search, hash } = useLocation();
    const { config } = useTemplateConfig();
    const storeName = config.identidad.vchNombreTienda;

    useEffect(() => {
        if (typeof window !== "undefined") {
            try {
                window.scrollTo({ top: 0, left: 0, behavior: "auto" });
            } catch {
                (document.body as HTMLElement).scrollTop = 0;
                (document.documentElement as HTMLElement).scrollTop = 0;
            }
        }

        try {
            const normalized = (pathname || "").replace(/\/+$/g, "");

            if (/^\/productos(\/)?$/i.test(normalized)) {
                document.title = `Compra online productos en ${storeName}`;
                return;
            }

            if (/^\/productos\//i.test(normalized)) {
                const segments = normalized.split("/");
                const rawSku = decodeURIComponent(segments[segments.length - 1] || "");
                document.title = formatProductTitle(rawSku, storeName);
                return;
            }

            if (/^\/categoria\//i.test(normalized)) {
                const segments = normalized.split("/");
                const rawSku = decodeURIComponent(segments[segments.length - 1] || "");
                const formatted = formatCategoryName(rawSku);
                document.title = `Compra online ${formatted} en ${storeName}`;
                return;
            }

            document.title = storeName;
        } catch {
            document.title = storeName;
        }
    }, [pathname, search, hash, storeName]);

    return null;
};

export default ScrollToTop;
